package com.sddamico.draftmachine.pages.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.sddamico.draftmachine.components.layouts.LoadingFrame
import com.sddamico.draftmachine.components.layouts.MobileFrame
import com.sddamico.draftmachine.components.pwa.PushDiagnosticsPanel
import com.sddamico.draftmachine.components.sections.AppHeader
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmSpacing
import com.sddamico.draftmachine.ds.displayBlock
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.roleBody
import com.sddamico.draftmachine.ds.roleH2
import com.sddamico.draftmachine.util.LoadState
import com.sddamico.draftmachine.util.rememberAuthState
import com.sddamico.draftmachine.util.transitionTo
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.dom.Div

/**
 * `/settings/alerts` — the browser-push workshop. Kept off `/settings` because the check registers a
 * service worker and hits the network on mount; that shouldn't fire every time someone edits a username.
 */
@Page
@Composable
fun AlertsPage() {
  val ctx = rememberPageContext()
  val auth = rememberAuthState()

  when (val state = auth.value) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> {
      LaunchedEffect(Unit) { ctx.router.transitionTo("/login") }
      LoadingFrame()
    }
    is LoadState.Ready -> {
      val user = state.value
      if (user == null) {
        LaunchedEffect(Unit) { ctx.router.transitionTo("/login") }
        LoadingFrame()
      } else {
        MobileFrame(
          modifier = Modifier.displayFlex().flexDirection(FlexDirection.Column),
          header = {
            AppHeader(
              email = user.email,
              title = "Browser alerts",
              onBack = { ctx.router.transitionTo("/settings") },
            )
          },
        ) {
          Div(attrs = Modifier.padding(DmSpacing.space6).toAttrs()) {
            SpanText(
              "Alert wiring",
              Modifier.roleH2().displayBlock().margin(bottom = DmSpacing.space2),
            )
            SpanText(
              "Confirm this browser can receive on-the-clock pushes — and prove it with a live test signal.",
              Modifier.roleBody().color(DmColor.textSecondary).displayBlock()
                .margin(bottom = DmSpacing.space6),
            )
            PushDiagnosticsPanel()
          }
        }
      }
    }
  }
}

